import { GrantsType, hasScopedPermission } from '../../Shared/utils/auth';

export const nonRenewalPolicy = (grants: GrantsType) =>
  hasScopedPermission(grants, 'partner', 'policies.cancellation.non_renewal');

export const customerInitiatedCancellationPolicy = (grants: GrantsType) =>
  hasScopedPermission(
    grants,
    'partner',
    'policies.cancellation.customer_initiated'
  );

export const carrierInitiatedCancellationPolicy = (grants: GrantsType) =>
  hasScopedPermission(
    grants,
    'partner',
    'policies.cancellation.carrier_initiated'
  );

export const cancelPolicies = (grants: GrantsType) =>
  customerInitiatedCancellationPolicy(grants) ||
  carrierInitiatedCancellationPolicy(grants);

export const reinstatementPolicy = (grants: GrantsType) =>
  hasScopedPermission(grants, 'partner', 'policies.reinstate');

export const withdrawCancellationPolicy = (grants: GrantsType) =>
  hasScopedPermission(grants, 'partner', 'policies.cancellation.withdraw');
